// src/js/reducers/index.js
import * as types from "../constants/action-types";

export default function fileTypeReducer(state = [], action) {
    switch (action.type) {
       
        case types.LOGOUT:
            return []
        case types.LOAD_FILETYPES_SUCCESS:
            return action.fileTypes;
        
        default:
            return state;
    };
};

